import React from 'react';

const TelegramIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M14.451 8.879c.482-.5.961-1.68-1.048-.252-2.854 2.059-5.666 3.991-5.666 3.991a2.264 2.264 0 0 1-1.849.042c-1.205-.378-2.612-.882-2.612-.882s-.961-.631.684-1.3c0 0 6.952-2.982 9.363-4.033.924-.42 4.058-1.764 4.058-1.764s1.447-.589 1.326.84c-.04.588-.362 2.647-.683 4.873-.483 3.15-1.005 6.6-1.005 6.6s-.08.966-.763 1.134a3.22 3.22 0 0 1-2.008-.756c-.161-.126-3.014-2.017-4.059-2.94a.816.816 0 0 1 .04-1.345 160.705 160.705 0 0 0 4.222-4.208z" transform="translate(.743 1.45)" fill={'#ffffff'}/>
    </svg>
  );
};

export default TelegramIcon;
